import { render } from "./ProductGroupComponent.vue?vue&type=template&id=470efd8d&scoped=true"
import script from "./ProductGroupComponent.vue?vue&type=script&lang=js"
export * from "./ProductGroupComponent.vue?vue&type=script&lang=js"

import "./ProductGroupComponent.vue?vue&type=style&index=0&id=470efd8d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470efd8d"]])

export default __exports__